module.exports = __webpack_public_path__ + "static/Apercu-Medium-729c1cd469535c7ddcb8cb95a69566bf.ttf";